import i18n from '@/core/i18n';

import { ProjectChangedFieldNameDTO } from '../../types/dto/project-changed-field.dto';

/**
 * Gets the localized value for a value key
 */
export const getLocalizedValueKey = (key: string, t: (key: string) => string): string => {
  const translationKey = `details.tabs.changes.valueKeys.${key}`;
  const translated = t(translationKey);
  // If translation returns the key itself, it means no translation found, return original
  return translated === translationKey ? key : translated;
};

/**
 * Formats a field value for display
 * Handles dates, percentages, and primitives
 */
export const formatFieldValue = (
  value: string | null,
  t: (key: string) => string,
  fieldName?: string
): string => {
  if (!value) return '';

  // Handle TENTATIVE_PROBABILITY - multiply by 100 and add %
  if (fieldName === ProjectChangedFieldNameDTO.TENTATIVE_PROBABILITY) {
    const numValue = parseFloat(value);
    if (!isNaN(numValue)) {
      return `${(numValue * 100).toFixed(0)}%`;
    }
  }

  // Check if it's a date FIRST (before localization) - ISO format
  if (value.includes('T') || /^\d{4}-\d{2}-\d{2}/.test(value)) {
    try {
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        return date.toLocaleDateString('en-US', {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        });
      }
    } catch {
      // Fall through to try other formats
    }
  }

  // Try to get localized value if it looks like a key
  const localizedValue = getLocalizedValueKey(value, t);
  if (localizedValue !== value) {
    return localizedValue;
  }

  return value;
};

/**
 * Formats a value with currency
 */
export const formatValueWithCurrency = (value: string, currency: string | null): string => {
  if (!currency) return value;
  return i18n.t('authenticated.projects:details.tabs.changes.valueDisplay.withCurrency', {
    value,
    currency,
  });
};
